import { createContext, useContext, useMemo, ReactNode } from 'react';

export interface EditorScope {
  documentId: number | string;
  documentRevisionId?: string;
  sectionId?: string;
  sectionRevisionId?: string;
  translationId?: string;
  useDraft?: boolean;
  withStyle?: unknown;
  embedd?: boolean;
}

const EditorScopeContext = createContext<EditorScope | null>(null);

export const EditorScopeProvider = ({ scope, children }: { scope: EditorScope; children: ReactNode }) => {
  const { documentId, documentRevisionId, sectionId, sectionRevisionId, translationId, useDraft, withStyle, embedd } = scope;

  const value = useMemo(
    () => ({ documentId, documentRevisionId, sectionId, sectionRevisionId, translationId, useDraft, withStyle, embedd }),
    [documentId, documentRevisionId, sectionId, sectionRevisionId, translationId, useDraft, withStyle, embedd]
  );

  return <EditorScopeContext.Provider value={value}>{children}</EditorScopeContext.Provider>;
};

export const useEditorScope = (): EditorScope | null => useContext(EditorScopeContext);
